"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMessage = getMessage;

var _messages = require("../messages");

function getMessage(text, extra) {
  if (extra) {
    switch (extra.type) {
      case 'sent':
        return "".concat(_messages.messages[extra.type], " <br/><a class=\"mew-connect-notifier-created-tx-link\" href=\"").concat(extra.explorerPath.replace('[[txHash]]', extra.hash), "\" target=\"_blank\">View details</a>");

      case 'failed':
        return "".concat(_messages.messages[extra.type], " <br/><a class=\"mew-connect-notifier-created-tx-link\" href=\"").concat(extra.explorerPath.replace('[[txHash]]', extra.hash), "\" target=\"_blank\">View details</a>");

      case 'nonStandardMessage':
        return extra.message;
    }
  }

  var regEx = new RegExp(/^Returned error:/);

  if (regEx.test(text)) {
    return text;
  }

  if (!text) {
    return _messages.messages.defaultMessage;
  }

  return _messages.messages[text];
}